import type { InputHTMLAttributes, CSSProperties } from 'react';

// Input — minimal text input. Surface-3 background, hairline border, ore focus
// ring (1px) on focus. Forwards every standard HTML input attribute (type,
// value, onChange, placeholder, …). Keeps the component theme-token-driven so
// it switches between light and dark automatically.
type InputProps = InputHTMLAttributes<HTMLInputElement>;

export function Input({ className, style, ...rest }: InputProps) {
  const baseStyle: CSSProperties = {
    background: 'var(--surface-3)',
    color: 'var(--ink-primary)',
    border: '1px solid var(--hairline)',
    borderRadius: '8px',
    padding: '6px 10px',
    fontSize: '13px',
    fontFamily: 'inherit',
    outline: 'none',
    transition: 'border-color 120ms ease',
    ...style,
  };
  return <input className={className} style={baseStyle} {...rest} />;
}
